import TrustLockup from './TrustLockup'
import ThemeToggle from './ThemeToggle'

/* ============================================================
   InviteOnly — the bare-domain dead-end (no ?p=<slug> invite link). Restyled to
   live in the SAME place as the cinematic welcome / ThankYouScreen: theme-aware
   grey/dark wash, the big blind-debossed spiral on the RIGHT, content
   left-anchored in the welcome column on the LEFT.

   It mirrors ThankYouScreen's shell verbatim (.sw-welcome-layer .is-in .ty-layer,
   .sw-brandmark, .sw-emboss, .sw-final-body, .sw-welcome, .bottom-bar) so the
   wash + spiral are pixel-identical in light + dark. Only the copy differs: the
   invite-only message and a support email — no success icon/rings, no reference
   id, no Begin, no resume, no form.
   ============================================================ */

export default function InviteOnly() {
  return (
    <div className="sw-welcome-layer is-in ty-layer">
      {/* theme toggle — same control as the welcome, top-right */}
      <ThemeToggle className="sw-theme-toggle" />

      {/* brand anchor — full teal icon + BRITE wordmark lockup, top-left */}
      <img
        className="sw-brandmark"
        src="/welcome/brite-lockup-dark.png"
        alt="BRITE"
      />

      {/* RIGHT — brand as material: huge blind-debossed spiral in the grey */}
      <div className="sw-emboss" aria-hidden="true" />

      {/* LEFT — the invite-only message, left-anchored in the welcome column */}
      <div className="sw-final-body">
        <div className="sw-welcome ty-welcome">
          <div className="sw-welcome-rule" aria-hidden="true" />

          <h1 className="success-v2-headline">
            Onboarding is by invitation.
          </h1>
          <p className="success-v2-subline">
            BRITE practice onboarding is set up through a unique invite link. If
            you'd like to sign up with BRITE, reach out to us and we'll get you
            started.
          </p>

          <div className="success-v2-actions">
            <a
              href="mailto:support@brite.live"
              className="success-v2-cta-secondary"
            >
              support@brite.live
            </a>
          </div>
        </div>
      </div>

      <footer className="bottom-bar">
        <div className="bb-left" aria-hidden="true" />
        <div className="bb-center">
          <TrustLockup />
        </div>
        <div className="bb-right" aria-hidden="true" />
      </footer>
    </div>
  )
}
